export const NAVBAR_COLLAPSED_WIDTH = 56;
export const NAVBAR_EXPANDED_WIDTH = 160;
export const NAVBAR_ITEM_COLLAPSED_WIDTH = 40;
export const NAVBAR_ITEM_EXPANDED_WIDTH = 144;
export const NAVBAR_ITEM_HEIGHT = 40;
